import { render, staticRenderFns } from "./ExpansionCard.vue?vue&type=template&id=6b0d6b13&"
import script from "./ExpansionCard.vue?vue&type=script&lang=ts&"
export * from "./ExpansionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports